/******************
* Create and insert a little Tooltip / Popover window
*
*
* Documentation
*     See the repository's Wiki on GitHub.com:
*     https://github.com/fournova/kirby-toolbox/wiki/javascript:-tooltips.js
*
*/

if(typeof FN == 'undefined') FN = {};

FN.tooltips = {
  config: {
    dimensions: {
      pointerYDistance: 2,
      pointerHeightPixels: 14,
      pointerWidthPixels: 32,
      pointerHorizontalInsetPixels: 6,
      boxBorderWidth: 1
    },
    selectors: {
      tooltipIndicatorClass: 'tooltip-indicator',
      tooltipId: 'tooltip',
      tooltipContentDataAttr: "data-content",
      tooltipPositionDataAttr: "data-pointer-position"
    }
  },
  

  /**
    Init
  */
  init: function(){
    document.querySelectorAll('.' + FN.tooltips.config.selectors.tooltipIndicatorClass).forEach(function(indicator){
      indicator.addEventListener('mouseenter', function(){
        FN.tooltips.showTooltip(indicator);
      });
      indicator.addEventListener('mouseleave', function(){
        FN.tooltips.hideTooltips();
      });
    });

  },


  /**
    Create and show a tooltip
  */
  showTooltip: function(indicatorItem){
    FN.tooltips.hideTooltips();     // remove all existing tooltips (just to be sure...)

    var tooltipText = indicatorItem.getAttribute(FN.tooltips.config.selectors.tooltipContentDataAttr);
    var pointerAttr = indicatorItem.getAttribute(FN.tooltips.config.selectors.tooltipPositionDataAttr) || 'bottom-center';
    var tooltipPointerPosition = pointerAttr.split('-');
    tooltipPointerPosition = { y: tooltipPointerPosition[0], x: tooltipPointerPosition[1] };

    var html = '<div id="'+ FN.tooltips.config.selectors.tooltipId +'">';
    html    += '<div class="tooltip__pointer tooltip__pointer--'+ tooltipPointerPosition.x +' tooltip__pointer--'+ tooltipPointerPosition.y +'"></div>';
    html    += '<div class="tooltip__text">'+ tooltipText +'</div>';
    html    += '</div>';

    indicatorItem.insertAdjacentHTML('beforeend', html);

    var tooltipEl = indicatorItem.querySelector('#' + FN.tooltips.config.selectors.tooltipId);
    if (!tooltipEl) return;

    var indicatorRect = indicatorItem.getBoundingClientRect();
    var tooltipRect = tooltipEl.getBoundingClientRect();

    var indicatorItemWidth = indicatorRect.width;
    var indicatorItemHeight = indicatorRect.height;
    var tooltipHeight = tooltipRect.height;
    var tooltipWidth = tooltipRect.width + (2 * FN.tooltips.config.dimensions.boxBorderWidth);

    var tooltipPosition = {};
    if(tooltipPointerPosition.x === 'left') {
      tooltipPosition.left = (indicatorItemWidth / 2 - FN.tooltips.config.dimensions.pointerWidthPixels / 2 - FN.tooltips.config.dimensions.pointerHorizontalInsetPixels);
    }else if(tooltipPointerPosition.x === 'right') {
      tooltipPosition.right = (indicatorItemWidth / 2 - FN.tooltips.config.dimensions.pointerWidthPixels / 2 - FN.tooltips.config.dimensions.pointerHorizontalInsetPixels);
    }else{    // 'center' and default
      tooltipPosition.left = (indicatorItemWidth / 2 - tooltipWidth / 2);
    }

    if(tooltipPointerPosition.y === 'top') {
      tooltipPosition.top = (indicatorItemHeight + FN.tooltips.config.dimensions.pointerHeightPixels + FN.tooltips.config.dimensions.pointerYDistance);
    }else{    // 'bottom' and default
      tooltipPosition.bottom = (indicatorItemHeight + FN.tooltips.config.dimensions.pointerHeightPixels + FN.tooltips.config.dimensions.pointerYDistance);
    }

    if('left' in tooltipPosition) tooltipEl.style.left = tooltipPosition.left + 'px';
    if('right' in tooltipPosition) tooltipEl.style.right = tooltipPosition.right + 'px';
    if('top' in tooltipPosition) tooltipEl.style.top = tooltipPosition.top + 'px';
    if('bottom' in tooltipPosition) tooltipEl.style.bottom = tooltipPosition.bottom + 'px';
    tooltipEl.style.display = 'block';
  },


  /**
    Hide all tooltips
  */
  hideTooltips: function(){
    document.querySelectorAll('#' + FN.tooltips.config.selectors.tooltipId).forEach(function(el){
      el.remove();
    });
  }  
};




// load configured tooltips - but only once the page is completely loaded
window.addEventListener('load', function(){
  FN.tooltips.init();
});
